import { useState, useEffect } from 'react'
import { loadSuppliers, createSupplier, deleteSupplier, Supplier } from '../lib/apiPhpAdapter'
import './SuppliersManagement.css'

function SuppliersManagement() {
  const [suppliers, setSuppliers] = useState<Supplier[]>([])
  const [loading, setLoading] = useState(true)
  const [showAddForm, setShowAddForm] = useState(false)
  const [newSupplier, setNewSupplier] = useState({ name: '', ico: '' })
  const [submitting, setSubmitting] = useState(false)
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    loadSuppliersData()
  }, [])

  const loadSuppliersData = async () => {
    try {
      setLoading(true)
      const data = await loadSuppliers()
      setSuppliers(data)
    } catch (error) {
      console.error('Chyba při načítání dodavatelů:', error)
      alert('Chyba při načítání dodavatelů')
    } finally {
      setLoading(false)
    }
  }

  const handleAddSupplier = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!newSupplier.name.trim()) {
      alert('Název dodavatele je povinný')
      return
    }

    try {
      setSubmitting(true)
      await createSupplier(newSupplier.name.trim(), newSupplier.ico.trim() || undefined)
      await loadSuppliersData()
      setNewSupplier({ name: '', ico: '' })
      setShowAddForm(false)
      alert('Dodavatel byl úspěšně přidán')
    } catch (error) {
      console.error('Chyba při přidávání dodavatele:', error)
      alert('Chyba při přidávání dodavatele')
    } finally {
      setSubmitting(false)
    }
  }

  const handleDeleteSupplier = async (id: string, name: string) => {
    if (!confirm(`Opravdu chcete smazat dodavatele "${name}"?`)) {
      return
    }

    try {
      await deleteSupplier(id)
      await loadSuppliersData()
      alert('Dodavatel byl úspěšně smazán')
    } catch (error) {
      console.error('Chyba při mazání dodavatele:', error)
      alert('Chyba při mazání dodavatele')
    }
  }

  const filteredSuppliers = suppliers.filter(supplier =>
    supplier.name.toLowerCase().includes(searchText.toLowerCase()) ||
    (supplier.ico && supplier.ico.includes(searchText))
  )

  return (
    <div className="suppliers-management">
      <div className="suppliers-header">
        <h2>📋 Správa dodavatelů</h2>
        <button 
          onClick={() => setShowAddForm(!showAddForm)} 
          className="add-supplier-button"
        >
          {showAddForm ? '✖ Zrušit' : '➕ Přidat dodavatele'}
        </button>
      </div>

      {showAddForm && (
        <div className="add-supplier-form">
          <form onSubmit={handleAddSupplier}>
            <div className="form-row">
              <div className="form-group">
                <label>
                  Název dodavatele <span className="required">*</span>
                </label>
                <input
                  type="text"
                  value={newSupplier.name}
                  onChange={(e) => setNewSupplier({ ...newSupplier, name: e.target.value })}
                  placeholder="Název dodavatele"
                  required
                />
              </div>
              <div className="form-group">
                <label>IČO</label>
                <input
                  type="text"
                  value={newSupplier.ico}
                  onChange={(e) => setNewSupplier({ ...newSupplier, ico: e.target.value })}
                  placeholder="12345678"
                  maxLength={20}
                />
              </div>
            </div>
            <div className="form-actions">
              <button type="submit" className="submit-button" disabled={submitting}>
                {submitting ? 'Přidávání...' : 'Přidat'}
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="suppliers-search">
        <input
          type="text"
          placeholder="🔍 Hledat dodavatele (název nebo IČO)..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <div className="loading">Načítání...</div>
      ) : (
        <div className="suppliers-list">
          {filteredSuppliers.length === 0 ? (
            <div className="no-suppliers">
              {searchText ? 'Žádní dodavatelé neodpovídají hledání' : 'Žádní dodavatelé v seznamu'}
            </div>
          ) : (
            <div className="intranet-table-scroll suppliers-table-wrap">
            <table className="suppliers-table">
              <thead>
                <tr>
                  <th>Název dodavatele</th>
                  <th>IČO</th>
                  <th>Přidáno</th>
                  <th>Akce</th>
                </tr>
              </thead>
              <tbody>
                {filteredSuppliers.map(supplier => (
                  <tr key={supplier.id}>
                    <td className="supplier-name">{supplier.name}</td>
                    <td className="supplier-ico">{supplier.ico || '-'}</td>
                    <td className="supplier-date">
                      {new Date(supplier.created_at).toLocaleDateString('cs-CZ')}
                    </td>
                    <td className="supplier-actions">
                      <button
                        onClick={() => handleDeleteSupplier(supplier.id, supplier.name)}
                        className="delete-button"
                        title="Smazat dodavatele"
                      >
                        🗑️ Smazat
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
      )}

      <div className="suppliers-info">
        <p>📊 Celkem dodavatelů: <strong>{suppliers.length}</strong></p>
      </div>
    </div>
  )
}

export default SuppliersManagement
